module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABSklEQVQ4T5XSv0vWURTH8dfpT7BAoUWXIEGoQYIENWhqSDD6G4pcIgeFNh2cLAgc0r0h8D+QctAIbBFaEpRyc/AHmlZGXTnwfeLLA8+j3eVy7z3nfc7nfG5AKeUZHuBSntuswGc8j4idjItSyhPMnZPY/LyCEZwm4B3u/CdgFp3oT8B7DOMvFnHUBnYVN3EfH1N9HbCBGxHxoxWglHINt/EYt/CyDsi8TP7VAlDwBa/wBrvoaQacN4qBSmYXHkXEfB3wDfdw3ILyB08xnlZGRF/DxsYQf6YmHLYAZNtf0/rKtU8R8f2iEqZwHQ/xFjnwhYjYrgNOK32511e2ntWX8uNgEB9wJSL264BN3MXvJsABujGKk8q+7ORyROxdRMIYJvAaq1iuCvwD5MVQG/+msVa1/wK9VWxHQ8IkZtoA0p2tWmKGrueXjohyBl/bfX6lw19NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/remark.png
// module id = FeES
// module chunks = 2